import './css/styles.scss';

function statistikkortInit(): void {}

statistikkortInit();
